import request from "_private/utils/request";

/**
 * 获取企业信用排行表头字段
 * @param 无参数
 */
export function FetchTableColumn() {
    return request({
        url: "/compary/credit/getPageColumn",
        method: "post"
    });
}

/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchFindByPage(data) {
    return request({
        url: "/compary/credit/findByPage",
        method: "post",
        headers: {type: "json"},
        data
    });
}
